<template>
    <div class="box-container" :style="{ backgroundColor: bgColor }">
        <img :src="img" alt="logo" width="100" height="100">
        <h1>{{ title }}</h1>
    </div>

</template>
  
<script>

export default {
  name: 'TecnologiesBox',
  props: {
    title: String,
    img: String,
    bgColor: {
      type: String,
      default: '#fdf9f8',
    }
  }
}

</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>     
.box-container{
  width: 14em;
  height: 15em;
  border-radius: 0.8em;
  transition: transform 0.6s;
  z-index: 1;
  border: 2px solid #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
}

.box-container:hover{
  transform: scale(1.05);
  box-shadow: 0.2em 0.2em 0em 0.1em #494949;
  transition: 0.3s;
}


</style>